import React, { useState, useMemo, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react';
import {
    ClientSideRowModelModule,
    ValidationModule,
    TextEditorModule,
    NumberEditorModule
} from 'ag-grid-community';

import { styled } from '@mui/system';  // Import styled from MUI


import { Typography, Box } from '@mui/material';

const GridWrapper = styled('div')`
  .ag-theme-alpine .ag-cell, 
  .ag-theme-alpine .ag-header-cell {
    border: 1px solid #dcdcdc;  /* Light gray border color */
  }

  .ag-theme-alpine .ag-row {
    border-bottom: 1px solid #dcdcdc;  /* Border between rows */
  }

  /* Adding border to the left and right of each cell */
  .ag-theme-alpine .ag-cell {
    border-left: 1px solid #dcdcdc;  /* Border to the left of cells */
    border-right: 1px solid #dcdcdc; /* Border to the right of cells */
  }

  /* Border for column header cells */
  .ag-theme-alpine .ag-header-cell {
    border-left: 1px solid #dcdcdc;  /* Left border for headers */
    border-right: 1px solid #dcdcdc; /* Right border for headers */
  }
`;

// Don't import ag-grid.css or ag-theme-alpine.css
// Instead, use ag-theme-alpine or ag-theme-material classes in the container

let _data = []

for (let n = 0; n < 100; n += 1) {
    _data.push({
        id: (n + 1),
        name: `John Doe ${n + 1}`,
        age: 30 + (n + 1)
    })
}

// let _data1 = [
//     { id: 1, name: 'John Doe', age: 30 },
//     { id: 2, name: 'Jane Smith', age: 25 },
//     { id: 3, name: 'Alice Johnson', age: 28 },
//     { id: 4, name: 'Jane Smith', age: 25 },
//     { id: 5, name: 'Alice Johnson', age: 28 },
//     { id: 6, name: 'Jane Smith', age: 25 },
//     { id: 7, name: 'Alice Johnson', age: 28 },
//     { id: 8, name: 'Jane Smith', age: 25 },
//     { id: 9, name: 'Alice Johnson', age: 28 },
//     { id: 10, name: 'Jane Smith', age: 25 },
//     { id: 11, name: 'Alice Johnson', age: 28 },
// ]

// let _data = [
//     ..._data1,
//     ..._data1,
//     ..._data1,
//     ..._data1,
//     ..._data1,
//     ..._data1,
// ]

const MyDataGrid = () => {

    const [rowData, setRowData] = useState(_data);

    const onRowDataChange = (updatedRow) => {
        setRowData(prevData =>
            prevData.map(row => (row.id === updatedRow.id ? updatedRow : row))
        );
    };

    const columnDefs = useMemo(() => [
        { field: 'id', headerName: 'ID', editable: false },
        { field: 'name', headerName: 'Name', editable: true },
        { field: 'age', headerName: 'Age', editable: true },
        { field: 'age1', headerName: 'Age', editable: true },
        { field: 'age2', headerName: 'Age', editable: true },
        { field: 'age3', headerName: 'Age', editable: true },
        { field: 'age4', headerName: 'Age', editable: true },
        { field: 'age5', headerName: 'Age', editable: true },
        { field: 'age6', headerName: 'Age', editable: true },
        { field: 'age7', headerName: 'Age', editable: true },
        { field: 'age7', headerName: 'Age', editable: true },
        { field: 'age8', headerName: 'Age', editable: true },
        { field: 'age9', headerName: 'Age', editable: true },
        { field: 'age10', headerName: 'Age', editable: true },
    ], []);

    const defaultColDef = useMemo(() => ({
        flex: 1,
        minWidth: 100,
        resizable: true,
    }), []);

    const onCellValueChanged = useCallback((event) => {
        onRowDataChange(event.data);
    }, [onRowDataChange]);

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flex: 1 }}>
                <Typography
                    sx={{
                        fontSize: 9
                    }}
                >
                    {JSON.stringify(rowData)}
                </Typography>
                <Box
                    className="ag-theme-alpine"
                    sx={{
                        width: '100%',
                        height: '100%',
                        '& .ag-theme-alpine .ag-cell, .ag-theme-alpine .ag-header-cell': {
                            border: '1px solid #dcdcdc',  // Full border for cells and header
                        },
                        '& .ag-theme-alpine .ag-row': {
                            borderBottom: '1px solid #dcdcdc',  // Border between rows
                        },
                        '& .ag-theme-alpine .ag-cell': {
                            borderLeft: '1px solid #dcdcdc',  // Left border for cells
                            borderRight: '1px solid #dcdcdc', // Right border for cells
                        },
                        '& .ag-theme-alpine .ag-header-cell': {
                            borderLeft: '1px solid #dcdcdc',  // Left border for headers
                            borderRight: '1px solid #dcdcdc', // Right border for headers
                        }
                    }}
                >

                    <AgGridReact
                        modules={[
                            ClientSideRowModelModule,
                            ValidationModule,
                            TextEditorModule,
                            NumberEditorModule
                        ]}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        // editType="fullRow"
                        domLayout='autoHeight'
                        rowHeight={25}  // Reduce the row height
                        onCellValueChanged={onCellValueChanged}
                    />
                </Box>
            </div>
        </div>
    );
};

export default MyDataGrid;
